import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FilterByFamily } from '@core/model/FilterByFamily.model';
import { ProductFamilyService } from '@shared/service/productFamily.service';
import { SearchModel } from '@core/model/search.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FilterDetail } from '@core/model/FilterDetail.model';
import { utiles } from '@utl/environment';

@Component({
  selector: 'app-modal-filters',
  templateUrl: './modal-filters.component.html',
  styleUrls: ['./modal-filters.component.scss'],
})
export class ModalFiltersComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  private oldFilters: FilterByFamily[] = [];
  private oldFamilySelected = '';
  public selectedFilters: FilterByFamily[] = [];
  public filtersByFamily: FilterByFamily[] = [];
  public searchModelFiltItems: SearchModel = new SearchModel();
  public familyFilterListApply: FilterByFamily[] = [];
  public initialFilters = '';
  public initialFiltersByFamily = '';
  public filter: [];
  public optionType: any;
  public optionSelected: any;
  public localFilterDetail: FilterDetail[] = [];

  // Parámetros nuevos para recargas valores de filtros
  public currencyModel: any;
  public CustAccount: string;
  public ProjectId: string;
  public ItemName: string;
  public UserId: number;
  public PageNum: number;
  public MaxRowsPage: number;
  public FamilyId: string;
  // ==================================================

  onCancel = new EventEmitter();
  onApplyFilters = new EventEmitter();

  isChecked;
  isCheckedName;
  isCheckedFamily;
  isCheckFilterId;

  constructor(
    private productFamilyService: ProductFamilyService,
    public dialogRef: MatDialogRef<ModalFiltersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data !== null && this.data !== undefined) {
      this.selectedFilters = JSON.parse(
        JSON.stringify(this.data.selectedFilters)
      );
      this.filtersByFamily = JSON.parse(
        JSON.stringify(this.data.filtersByFamily)
      );
      this.initialFilters = JSON.stringify(this.data.selectedFilters);
      this.initialFiltersByFamily = JSON.stringify(this.data.filtersByFamily);
      this.filter = this.data.filter;
      this.optionType = this.data.optionType;
      this.optionSelected = this.optionType;

      // Valores de searchproduct que se necesitan para filtrar
      this.currencyModel = utiles.getCacheSelectedCurrency();
      this.CustAccount = this.data.CustAccount;
      this.ProjectId = this.data.ProjectId;
      this.ItemName = this.data.ItemName;
      this.UserId = this.data.UserId;
      this.FamilyId = this.data.FamilyId;
      this.PageNum = this.data.PageNum;
      this.MaxRowsPage = this.data.MaxRowsPage;
      // ======================================================

      this.filtersByFamily.forEach((element) => {
        element.FilterDetails.forEach((detail) => {
          detail.FilterId = element.FilterId;
          detail.Detail = detail.QueryValue;

          if (
            this.selectedFilters !== null &&
            this.selectedFilters.length > 0
          ) {
            let selected = this.selectedFilters.filter(
              (l) => l.FilterId === detail.FilterId
            )[0];

            if (selected !== null && selected !== undefined) {
              let details = selected.QueryValue.split(',');
              detail.Checked =
                details.filter((l) => l === detail.Detail)[0] !== undefined
                  ? true
                  : false;
            }
          }
        });
      });
    }
  }

  ngOnInit() {}

  applyFilters() {
    this.selectedFilters.forEach(element => {
      element.JsonFilterChild = '[]';
      element.QueryValue = element.QueryValue.replace(',', '');
    });
    this.onApplyFilters.emit(this.selectedFilters);
  }

  cancel() {
    var data = {
      filtersByFamily: this.initialFiltersByFamily,
      selectedFilters: this.initialFilters,
    };
    this.onCancel.emit(data);
  }

  changeFilter(detail, filter) {
    this.filter = detail;
    this.optionSelected = filter;
  }

  goBack() {
    this.dialogRef.close();
  }

  onChangeFilterSelected(filter, $event) {
    let flag = 0;
    if ($event.checked) {
      flag = 1;
      if (this.selectedFilters === null || this.selectedFilters.length === 0) {
        this.selectedFilters = [];
      }
      
      if (filterFather !== null && filterFather !== undefined) {
        filterFather.QueryValue =
          (filterFather.QueryValue == null ? '' : filterFather.QueryValue) +
          filter.Detail +
          ',';
      } else {
        var filterFather = this.filtersByFamily.filter(
          (l) => l.FilterId === filter.FilterId
        )[0];
        filterFather.QueryValue =
          (filterFather.QueryValue == null ? '' : filterFather.QueryValue) +
          filter.Detail +
          ',';
        this.selectedFilters.push(filterFather);
      }
      
      this.localFilterDetail = [];
      this.localFilterDetail = [filter];
    } else {
      flag = 0;
      var filterFather = this.selectedFilters.filter(
        (l) => l.FilterId === filter.FilterId
      )[0];
      
      var queryValuesList = this.removeStringValue(
        filterFather.QueryValue,
        filter.Detail,
        ','
      );
      filterFather.QueryValue = queryValuesList;
      if (filterFather.QueryValue === '') {
        this.selectedFilters.splice(
          this.selectedFilters.indexOf(filterFather),
          1
        );
      }
    }
    this.GetItemsAndFilters();
    if (flag === 0) {
      this.localFilterDetail = filterFather.FilterDetails;
    }

    this.changeFilter(this.localFilterDetail, filter.FilterId);
  }

  GetItemsAndFilters() {
    let filters =
      this.selectedFilters === null || this.selectedFilters.length === 0
        ? []
        : this.selectedFilters;

    this.searchModelFiltItems.FilterList = JSON.stringify(filters);
    this.searchModelFiltItems.ItemName =
      this.ItemName !== undefined ? this.ItemName : '';
    this.searchModelFiltItems.UserId = this.UserId;
    this.searchModelFiltItems.PageNum = this.PageNum;
    this.searchModelFiltItems.MaxRowsPage = this.MaxRowsPage;
    this.searchModelFiltItems.Family = this.FamilyId;
    this.searchModelFiltItems.CustAccount = this.CustAccount;
    this.searchModelFiltItems.Currency = this.currencyModel.CurrencyId;
    
    this.productFamilyService
      .getItemsAndFilters(this.searchModelFiltItems)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.oldFilters = JSON.parse(JSON.stringify(this.selectedFilters));
        if (response.item2 !== '') {
          this.filtersByFamily = JSON.parse(response.item2);
          this.filtersByFamily.forEach((element) => {
            if (
              element.JsonFilterChild !== undefined &&
              element.JsonFilterChild !== ''
            ) {
              element.FilterDetails = JSON.parse(element.JsonFilterChild);
              element.QueryValue = '';
            } else {
              element.FilterDetails = [];
              element.QueryValue = '';
            }
          });
          this.filtersByFamily.forEach((element) => {
            element.FilterDetails.forEach((detail) => {
              if (detail.QueryValue !== undefined && detail.QueryValue !== '') {
                detail.FilterId = element.FilterId;
                detail.Detail = detail.QueryValue;

                if (this.selectedFilters !== null && this.selectedFilters.length > 0) {
                  let selected = this.selectedFilters.filter(
                    (l) => l.FilterId === detail.FilterId
                  )[0];

                  if (selected !== null && selected !== undefined) {
                    let details = selected.QueryValue.split(',');
                    detail.Checked =
                      details.filter((l) => l === detail.Detail)[0] !==
                      undefined
                        ? true
                        : false;
                  }
                }
              } else {
                detail.FilterId = element.FilterId;
                detail.Detail = '';
              }
            });
          });
          var filtersToDelete = [];
          this.filtersByFamily.forEach((element) => {
            let length = element.FilterDetails.length;
            let empty = 0;
            element.FilterDetails.forEach((detail) => {
              if (detail.Detail === '') {
                empty++;
              }
            });
            if (empty === length) {
              filtersToDelete.push(element);
            }
          });
          filtersToDelete.forEach((element) => {
            this.filtersByFamily.splice(
              this.filtersByFamily.indexOf(element),
              1
            );
          });
        }
      });
  }

  removeStringValue(list, value, separator) {
    separator = separator || ',';
    var values = list.split(separator);
    for (var i = 0; i < values.length; i++) {
      if (values[i] === value) {
        values.splice(i, 1);
        return values.join(separator);
      }
    }
    return list;
  }

  cleanFilters() {
    this.selectedFilters = [];
    this.onApplyFilters.emit(this.selectedFilters);
  }
}
